import mutations from './mutations';
import actions from './actions';
import getters from './getters';

export const initialMenu = () => ({
  categoryList: { list: [] },
  menuList: { list: [] },
  menuCount: null,
  menuDetail: {},
});

export default {
  state: initialMenu(),
  mutations,
  actions,
  getters,
  namespaced: true,
};
